<template>
  <v-row class="mt-0 mb-4 mb-lg-0">
    <v-col> </v-col>
    <v-col class="col-lg-3 col-12">
      <v-card :elevation="6" class="rounded-card" min-height="380">
        <v-card-title class="headline text-center justify-center">
          Inovação
        </v-card-title>
        <v-card-text>
          Desenvolvemos Projetos de Infraestrutura na área de Energia, com
          tecnologias de última geração aprimorando os conceitos de Comando e
          Proteção. E novas idéias de Subestações Compactas GIS para
          aproveitamento de espaços em áreas urbanas congestionadas.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn dark color="#25C135" @click.stop="dialog = true">
            Ver mais
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col class="col-lg-3 col-12">
      <v-card :elevation="6" class="rounded-card" min-height="380">
        <v-card-title class="headline text-center justify-center">
          EHS
        </v-card-title>
        <v-card-text>
          Nossa empresa adquiriu ao longo dos anos a filosofia do “Comportamento
          e Ação” princípios de comprometimento com a valorização dos nossos
          funcionários e colaboradores com sua saúde e segurança e com a
          conscientização para preservação do meio ambiente em nossas obras.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn dark color="#25C135" @click.stop="dialog = true">
            Ver mais
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col class="col-lg-3 col-12">
      <v-card :elevation="6" class="rounded-card" min-height="380">
        <v-card-title class="headline text-center justify-center">
          Responsabilidade
        </v-card-title>
        <v-card-text class="mb-5">
          Apresentamos sempre as melhores soluções aos nossos clientes com
          propostas e soluções dos melhores equipamentos do Mercado, que
          traduzam também junto aos fabricantes o conforto do atendimento no pós
          vendas. Cumprimos o prometido nos prazos e custos acordados.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn dark color="#25C135" @click.stop="dialog = true">
            Ver mais
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col> </v-col>
    <v-col class="col-12 d-flex justify-center" style="margin-top:-4em">
      <v-btn dark color="#25C135" @click="contact">
        Entre em contato
      </v-btn>
    </v-col>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="pa-1 pt-6 mt-6">
        <v-img src="../assets/flowchart.png" style="border-radius:5px" />
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    contact() {
      this.$router.push({ name: "contact" });
    }
  }
};
</script>
